import { motion } from "framer-motion";
import NavigationColored from './../components/NavigationColored';
const pageVariants = {
    initial: { scale: 0.9, opacity: 0 },
    in: { scale: 1, opacity: 1 },
    out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
    type: "tween",
    ease: "easeInOut",
    duration: 0.5,
};
const ConferenceHall = () => {
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
        >
            <NavigationColored />
            <div style={{ marginTop: '4em' }}></div>
            <section className="service">
                <div className="container">
                    <div className="section-title" style={{ marginBottom: "50px" }}>
                        <h1>Conference Hall</h1>
                        <p>“Where Big Ideas Meet Big Audiences.”</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-5 col-md-5">
                            <p align="justify">A conference hall provides a professional space for meetings, presentations, and team collaborations. Designed to create a productive environment, our conference halls are fully equipped with modern amenities such as high-definition projectors, audio-visual systems, whiteboards, and high-speed internet. Whether you're hosting a board meeting, client pitch, training session, or corporate seminar, our halls can be customized to suit your requirements. With comfortable seating, soundproof interiors, and on-demand technical support, your team and guests can focus entirely on the agenda without distractions. Refreshment services, ample parking, and a dedicated reception area ensure a smooth and professional experience from start to finish.</p>
                        </div>
                        <div className="col-lg-7 col-md-7 sub-services">
                            <ul>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </motion.div>
    )
}

export default ConferenceHall
